import { useEffect, useState } from 'react';
import { getEnvironment } from '@minecraft.environment';
import { GraphQLError } from 'graphql';
import { LegacyRedirectParamsResponse, LegacyRedirectRouteParams } from 'components/LegacyRedirect/LegacyRedirectTypes';

export type LegacyResponse = {
  data: LegacyRedirectParamsResponse;
  errors: GraphQLError[];
};

const useGetIdByLegacyId = (input: Partial<LegacyRedirectRouteParams>): LegacyResponse => {
  const [response, setResponse] = useState({} as LegacyResponse);
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      operationName: 'getRedirectParams',
      variables: {
        input,
      },
      query: `query getRedirectParams($input: RedirectInput!) {
          legacyParams: getIdByLegacyId(input: $input) {
            id
            inviationType
            profileGuid
            guid
            projectId
            presentationGroupId
            presentationFolderId
          }
        }`,
    }),
  };

  useEffect(() => {
    fetch(getEnvironment().API_URL, opts)
      .then((res) => res.json())
      .then((res) => {
        setResponse(res);
      })
      .catch((e) => setResponse(e));
  }, [input.legacyId]);

  return response;
};

export default useGetIdByLegacyId;
